
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/everydaySave",
      function () {
        return require("private-next-pages/everydaySave/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/everydaySave"])
      });
    }
  